module.exports = __webpack_public_path__ + "static/predictivepoem 10-01-6b9d180a9f77cd529a18f464b9f078a8.jpg";